angular.module('picmonicng').controller('MyPicmonicsController', [
  '$scope',
  'User',
  '$modal',
  '$filter',
  'UserService',
  '$cookies',
  '$stateParams',
  'ngBowser',
  '$window',
  'MarketSelectorModalService',
  function (
    $scope,
    User,
    $modal,
    $filter,
    UserService,
    $cookies,
    $stateParams,
    ngBowser,
    $window,
    MarketSelectorModalService
  ) {
    $scope.mobile = ngBowser.isMobile() || ngBowser.isTablet();
    $scope.picmonics = [];

    // Search
    $scope.search = {
      resource: 'picmonics',
      page: 1,
      per_page: 100,
    };

    $scope.back = function () {
      $window.history.back();
    };

    if (!UserService.user.user_id) {
      $scope.createNewPicmonic = function () {
        UserService.showRegisterModal(false, '/my-picmonics?create=1');
      };
      $scope.$emit('endInteraction');
    } else {
      $scope.previousPage = function () {
        if (!$scope.loading) {
          $scope.search.page--;
          $scope.doSearch();
        }
      };

      $scope.nextPage = function () {
        if (!$scope.loading) {
          $scope.search.page++;
          $scope.doSearch();
        }
      };

      $scope.doSearch = function () {
        $scope.loading = true;
        $scope.picmonics = User.getv3($scope.search);

        $scope.picmonics.$promise.then(function (data) {
          var picmonics = data.data;
          for (var a in picmonics) {
            var count = 0;
            var facts = $filter('orderBy')(picmonics[a].facts, ['order', 'fact_id']);
            for (var b in facts) {
              if (!facts[b].header) {
                facts[b].display_order = count;
                count++;
              }
            }

            $scope.picmonics.data[a].facts = facts;
          }

          $scope.loading = false;
          $scope.$emit('endInteraction');
        });
      };

      $scope.doSearch();

      $scope.createNewPicmonic = function () {
        $modal.open({
          templateUrl: '/templates/modals/create-picmonic.html',
          windowClass: 'white-modal',
          backdropClass: 'below-nav',
          size: 'md',
          controller: [
            '$scope',
            '$modalInstance',
            '$state',
            'User',
            '$timeout',
            'UserService',
            function ($scope, $modalInstance, $state, User, $timeout, UserService) {
              $timeout(function () {
                angular.element('input[name=name]').focus();
              }, 0);

              $scope.loading = false;

              $scope.createNewPicmonic = function () {
                if (!$scope.loading && $scope.create.$valid) {
                  $scope.loading = true;

                  if (!UserService.user.ugc_license) {
                    UserService.user.ugc_license = 1;
                    UserService.user.$update();
                  }

                  User.save({
                    resource: 'picmonics',
                    name: $scope.name,
                    topic_type_id: $scope.topic_type_id,
                  }).$promise.then(
                    function (picmonic) {
                      $state.go('app.editor', {
                        slug: picmonic.slug,
                        first_viewing: true,
                      });
                      $scope.close();
                    },
                    function () {
                      $scope.loading = false;
                    }
                  );
                }
              };

              $scope.close = function (event) {
                $modalInstance.close();
              };
            },
          ],
        });
      };

      $scope.deletePicmonic = function (picmonic) {
        $modal.open({
          templateUrl: '/templates/modals/delete-confirm.html',
          windowClass: 'below-nav learn-master-complete',
          backdropClass: 'below-nav',
          size: 'md',
          scope: $scope,
          controller: [
            '$scope',
            'Picmonics',
            function ($scope, Picmonics) {
              $scope.confirmation_text = 'Are you sure you want to delete this picmonic?';
              $scope.loading = false;

              $scope.confirm = function () {
                $scope.loading = true;
                Picmonics.delete({ card_id: picmonic.card_id }, function () {
                  $scope.picmonics.data.splice($scope.picmonics.data.indexOf(picmonic), 1);
                  $scope.$close();
                });
              };

              $scope.cancel = function () {
                $scope.$dismiss();
              };
            },
          ],
        });
      };

      if ($stateParams.create) {
        $scope.createNewPicmonic();
      }
    }
  },
]);
